// Messaging (push campaigns, templates, lists, mailing, lifecycle flows) is only switched on for
// these applications; it is not multi-tenant yet. Mirrors the server's MESSAGING_APP_IDS.
const MESSAGING_APP_IDS = new Set(
  (process.env.REACT_APP_MESSAGING_APP_IDS || '1')
    .split(',')
    .map((v) => Number(v.trim()))
    .filter((v) => Number.isInteger(v) && v > 0),
);

export const isMessagingEnabled = (appId) => MESSAGING_APP_IDS.has(Number(appId));
